import { createContext, useContext, useEffect, useRef, useState } from 'react';
import socketIOClient from 'socket.io-client';
import { config } from 'src/configs/constants';
import AuthContext from 'src/contexts/JWTAuthContext';

export const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const socketRef = useRef(null);
  const [connected, setConnected] = useState(false);

  // Cria a instância UMA ÚNICA VEZ (lazy init do useRef)
  if (socketRef.current === null) {
    socketRef.current = socketIOClient(config.url.SOCKET_URL || config.url.API_URL, {
      autoConnect: false,        // nós controlamos quando conectar
      reconnection: true,
      reconnectionAttempts: 5,   // para após 5 falhas
      reconnectionDelay: 2000,   // 2s antes do 1º retry
      reconnectionDelayMax: 30000, // teto de 30s entre tentativas
      randomizationFactor: 0.5,  // jitter para evitar thundering herd
      timeout: 10000,
    });
  }

  // Registra listeners de status uma única vez
  useEffect(() => {
    const socket = socketRef.current;

    const onConnect = () => setConnected(true);
    const onDisconnect = () => setConnected(false);
    const onConnectError = () => {
      if (!localStorage.getItem('accessToken')) {
        socket.disconnect();
      }
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('connect_error', onConnectError);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('connect_error', onConnectError);
      socket.disconnect();
    };
  }, []);

  // Conecta/desconecta conforme estado de autenticação
  useEffect(() => {
    const socket = socketRef.current;
    if (isAuthenticated) {
      if (!socket.connected) {
        socket.connect();
      }
    } else {
      socket.disconnect();
    }
  }, [isAuthenticated]);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current, connected }}>
      {children}
    </SocketContext.Provider>
  );
};
